import React from "react";
import { Btn, SectionHeading } from "./ui";
import { Reveal } from "./useReveal";
import { KestrelWidget } from "./KestrelWidget";
import { LINKS } from "./data";

// Home-page search section: renders the live iHomeFinder Listing Search
// widget, with CTAs into the full IDX experience at /idx.
export const IdxSection = () => (
  <section id="search" className="py-16 lg:py-24 bg-white">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          eyebrow="Home Search"
          title="Search Southern California Homes"
          subtitle="Browse available homes, explore local neighborhoods, and connect with Wallstreet Realty when you are ready to tour, write an offer, or understand your financing options."
          center
        />
        <p className="text-center text-sm text-[#2D2D37]/50 font-medium mt-4">
          Live MLS search powered by iHomeFinder IDX
        </p>
      </Reveal>

      <Reveal delay={120}>
        <div className="mt-10 bg-[#F5F5F5] border border-[#E5E5E5] rounded-[20px] p-4 sm:p-6">
          <KestrelWidget
            options={{ component: "listingSearchWidget" }}
            minHeight={220}
            testid="idx-listing-search"
          />
        </div>
      </Reveal>

      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Btn href={LINKS.idx} variant="primary" testid="idx-search-homes" pill>Open Full Home Search</Btn>
        <Btn href={LINKS.buyers} variant="outline" testid="idx-book-consultation">Book Buyer Consultation</Btn>
      </div>
    </div>
  </section>
);
